import React from "react";

export function Silhouette({ index }: { index: number }) {
    return <div className={`silhouette silhouette-${index}`}></div>;
}
